/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Integrations_G_AiInputs */

const tr_landing_integrations_g_ai = /** @type {(inputs: Landing_Integrations_G_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapay zeka`)
};

const en_landing_integrations_g_ai = /** @type {(inputs: Landing_Integrations_G_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI providers`)
};

const de_landing_integrations_g_ai = /** @type {(inputs: Landing_Integrations_G_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Künstliche Intelligenz`)
};

const ru_landing_integrations_g_ai = /** @type {(inputs: Landing_Integrations_G_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Искусственный интеллект`)
};

/**
* | output |
* | --- |
* | "AI providers" |
*
* @param {Landing_Integrations_G_AiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_integrations_g_ai = /** @type {((inputs?: Landing_Integrations_G_AiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Integrations_G_AiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_integrations_g_ai(inputs)
	if (locale === "de") return de_landing_integrations_g_ai(inputs)
	if (locale === "ru") return ru_landing_integrations_g_ai(inputs)
	return tr_landing_integrations_g_ai(inputs)
});